import { render } from "./Demo.vue?vue&type=template&id=1e5d071a&ts=true"
import script from "./Demo.vue?vue&type=script&lang=ts"
export * from "./Demo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__